import moment from 'moment'

export enum TimeFormatType {
  'excerto',
  'video',
}

export function formatSeconds(secondsParam: number, type?: TimeFormatType) {
  const duration = moment.duration(secondsParam, 'seconds')

  const hours = duration.hours() + duration.days() * 24
  const minutes = duration.minutes()
  const seconds = duration.seconds()

  const formatted = []

  if (hours > 0) {
    formatted.push(`${hours}h`)
  }

  if (minutes >= 0 && type === TimeFormatType.excerto) {
    formatted.push(`${minutes} minutos de leitura`)
  } else {
    formatted.push(`${minutes}min`)
  }

  if (formatted.length === 0) {
    formatted.push(`${seconds}s`)
  }

  return formatted.join(' ')
}
